module.exports = __webpack_public_path__ + "static/media/TLDR_9_impact.24ba3bb2.png";